/**
 * @file Comportement d'arme 'laser' : Laser (snipers) : faisceau instantane qui touche TOUTES les cibles shootable sur la ligne (largeur params.beamWidth).
 */
import type { SimContext } from '../../Context';
import { applyDamage, rollCrit } from '../../combat/damage';
import type { HitOutcome, ShotContext, WeaponBehaviorModule } from '../WeaponBehavior';
import { spawnBeam, targetsOnSegment } from './common';

/** fire : un critique pour tout le faisceau, degats a chaque cible de la ligne (ordre = distance) ; le faisceau est visuel. */
export const laserBehavior: WeaponBehaviorModule = {
  id: 'laser',
  fire(ctx: SimContext, shot: ShotContext): void {
    const w = shot.weapon;
    const p = w.params;
    const x1 = shot.originX + Math.cos(shot.aimAngle) * w.range;
    const y1 = shot.originY + Math.sin(shot.aimAngle) * w.range;
    const hits = targetsOnSegment(ctx, shot.originX, shot.originY, x1, y1, p.beamWidth / 2);
    const roll = rollCrit(ctx, w, w.damage);
    for (const t of hits) applyDamage(ctx, t, roll.damage, roll.crit, 'laser', shot.originX, shot.originY);
    spawnBeam(ctx, shot, 'laser', x1, y1, p.beamWidth, p.beamVisibleSeconds);
  },
  onHit(): HitOutcome {
    return { consumed: true };
  },
};
